import React from 'react';
import { Box, Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import {useLanguage} from "../../hooks/useLanguage";

export const AlertBlock = (props) => {
 const { t} = useLanguage()
  //journey_sex_error
  return (
    <React.Fragment>
      {props.validation && props.active ? (
        <div className={'alert-box'}>
          <Typography variant={'subtitle1'} align={'center'}>
            {props.copy ? props.copy : t('journey_sex_error')}
          </Typography>
        </div>
      ) : (
        <Box my={3.109}></Box>
      )}
    </React.Fragment>
  );
};
